"use strict";

exports.__esModule = true;
exports["default"] = exports.RadioGroup = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _ramda = require("ramda");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

var _radioButton = _interopRequireDefault(require("../radio-button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var RadioGroup = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "radio-sort__RadioGroup",
  componentId: "sc-e2nytn-0"
})(["border:none;margin:0;padding:0;"]);
exports.RadioGroup = RadioGroup;
var propTypes = {
  // Font parameters for each Radio Button
  buttonFont: (0, _propTypes.shape)({
    fontSize: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number, _propTypes.array])
  }),

  /** A boolean to represent whether the input field should be disabled */
  disabled: _propTypes.bool,

  /** Label for the group */
  groupLabel: _propTypes.node,
  // Name of radio button group
  groupName: _propTypes.string,
  // Font parameters for group label
  labelFont: (0, _propTypes.shape)({
    fontSize: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number, _propTypes.array])
  }),

  /** radioButtonOnChange event handler - used to process the event */
  radioButtonOnChange: _propTypes.func,
  // The currently selected sort option
  selectedOption: _propTypes.string,

  /** List of sort options, either array or object  */
  sortOptions: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    disabled: _propTypes.bool,
    id: _propTypes.string,
    label: _propTypes.string,
    value: _propTypes.string
  }))
};

var RadioSort = function RadioSort(_ref) {
  var buttonFont = _ref.buttonFont,
      _ref$labelFont = _ref.labelFont,
      labelFont = _ref$labelFont === void 0 ? _utils.defaultFontSize : _ref$labelFont,
      disabled = _ref.disabled,
      radioButtonOnChange = _ref.radioButtonOnChange,
      groupLabel = _ref.groupLabel,
      groupName = _ref.groupName,
      sortOptions = _ref.sortOptions,
      selectedOption = _ref.selectedOption;
  return /*#__PURE__*/_react["default"].createElement(RadioGroup, {
    disabled: disabled,
    flexDirection: "column",
    my: 2,
    tag: "fieldset"
  }, groupLabel ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    px: [3, 3, 0],
    tag: "legend"
  }, labelFont), groupLabel) : null, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    px: [3, 3, 0]
  }, (0, _ramda.map)(function (sortOption) {
    return /*#__PURE__*/_react["default"].createElement(_radioButton["default"], {
      key: sortOption.id,
      disabled: disabled || sortOption.disabled,
      fontObject: buttonFont,
      groupName: groupName,
      id: sortOption.id,
      isChecked: selectedOption === sortOption.value,
      label: sortOption.label,
      onChange: function onChange(event) {
        return (0, _ramda.not)(sortOption.disabled) && radioButtonOnChange(Object.assign({
          event: event
        }, sortOption));
      },
      value: sortOption.value
    });
  }, sortOptions)));
};

RadioSort.propTypes = propTypes;
RadioSort.displayName = "Modules.RadioSort";
var _default = RadioSort;
exports["default"] = _default;